import { render, staticRenderFns } from "./AppNavigationPhotosItem.vue?vue&type=template&id=1348e1f6&scoped=true"
import script from "./AppNavigationPhotosItem.vue?vue&type=script&lang=js"
export * from "./AppNavigationPhotosItem.vue?vue&type=script&lang=js"
import style0 from "./AppNavigationPhotosItem.vue?vue&type=style&index=0&id=1348e1f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1348e1f6",
  null
  
)

export default component.exports